module.exports = __webpack_public_path__ + "static/media/car-bus.b173b603.svg";